import { trim } from "./trim";

export const pathMatchFn = (
  href: string | RegExp,
  exact: boolean,
  pathname: string,
  locale: string,
): boolean => {
  if (typeof href === "string") {
    if (!href.startsWith("/")) href = `/${href}`;
  } else {
    href = trim(href.toString(), "/");
  }
  const closer = exact ? "$" : "";
  const normalizedHref =
    typeof href === "string" ? href.replace(/:[^/]+/g, "[^/]+") : href;
  const re = new RegExp(`^(?:/${locale})?${normalizedHref}/?${closer}`);
  return re.test(pathname);
};
